export function isSafari(): boolean {
  return navigator.userAgent.indexOf('Safari') > -1 &&
    navigator.userAgent.indexOf('Chrome') === -1 &&
    navigator.userAgent.indexOf('CriOS') === -1;
}

export function isDefined(value: any): boolean {
  return value !== undefined;
}
